export let moveTo = "IpM4Hc";
export default {moveTo};